import React, { useState } from 'react';
import { Search } from 'lucide-react';
import CategoryIcon, { ICON_REGISTRY } from './CategoryIcon';

const IconPicker = ({ value, onChange }) => {
  const [query, setQuery] = useState('');

  const filtered = query
    ? Object.keys(ICON_REGISTRY).filter(n => n.toLowerCase().includes(query.toLowerCase()))
    : Object.keys(ICON_REGISTRY);

  return (
    <div className="space-y-2">
      <div className="relative">
        <Search size={14} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-neutral-400" />
        <input
          type="text"
          placeholder="Icon suchen..."
          value={query}
          onChange={e => setQuery(e.target.value)}
          className="w-full pl-8 pr-3 py-1.5 text-sm border border-neutral-200 rounded-lg outline-none focus:ring-2 focus:ring-primary-500 bg-neutral-50"
        />
      </div>
      <div className="grid grid-cols-7 gap-1.5 max-h-44 overflow-y-auto pr-1">
        {filtered.map(name => (
          <button
            key={name}
            type="button"
            title={name}
            onClick={() => onChange(name)}
            className={`p-2 rounded-lg flex items-center justify-center transition-all ${
              value === name
                ? 'bg-primary-100 text-primary-700 ring-2 ring-primary-400'
                : 'bg-white border border-neutral-200 text-neutral-500 hover:bg-primary-50 hover:text-primary-600 hover:border-primary-200'
            }`}
          >
            <CategoryIcon name={name} size={16} />
          </button>
        ))}
      </div>
    </div>
  );
};

export default IconPicker;
